import React, { Component } from 'react'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import DocumentUploadUI from './DocumentUploadUI.js'

class DocumentUploadSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      // send docs to Novel Patterns
      npErrorList: null,
      npSuccessMsg: null,
      npSubmitted: false,
      // send docs to ScoreMe
      smErrorList: null,
      smSuccessMsg: null,
      smSubmitted: false,
      // download files
      downloadRequested: false,
      fileErrorList: null,
      // creditAssessmentDate modal
      updateDateMode: false,
      //
      clientTxnsReuploadErrorList: null,
      clientTxnsReuploadSuccessMsg: null,
      clientTxnsReuploadSubmitted: false,
      //
      deleteSubmitted: false
    }
  }

  render() {
    return (
      <DocumentUploadUI
        context={this.props.context}
        account={this.props.account}
        onRefreshClick={this.props.onRefreshClick}
        onCopyToClipboard={this.props.onCopyToClipboard}
        copyToClipboardText={this.props.copyToClipboardText}
        // send docs to Novel Patterns
        npErrorList={this.state.npErrorList}
        npSuccessMsg={this.state.npSuccessMsg}
        npSubmitted={this.state.npSubmitted}
        npFileList={this.props.npFileList}
        onNPSubmit={this.onNPSubmit}
        setNPErrorList={() => { }}
        // send docs to ScoreMe
        smErrorList={this.state.smErrorList}
        smSuccessMsg={this.state.smSuccessMsg}
        smSubmitted={this.state.smSubmitted}
        onSMSubmit={this.onSMSubmit}
        setSMErrorList={() => { }}
        // creditAssessmentDate modal
        updateDateMode={this.state.updateDateMode}
        onUpdateDateClick={() => { this.setState({ updateDateMode: true }) }}
        onCancelDateClick={() => { this.setState({ updateDateMode: false }) }}
        onAccountUpdate={this.props.onAccountUpdate}
        //
        onDownloadFileClick={this.onDownloadFileClick}
        fileErrorList={this.state.fileErrorList}
        //
        clientTxnsReuploadErrorList={this.state.clientTxnsReuploadErrorList}
        clientTxnsReuploadSuccessMsg={this.state.clientTxnsReuploadSuccessMsg}
        clientTxnsReuploadSubmitted={this.state.clientTxnsReuploadSubmitted}
        onClientTxnsReuploadClick={this.onClientTxnsReuploadClick}
        //
        onDeleteClick={this.onDeleteClick}
        deleteSubmitted={this.state.deleteSubmitted}
      />
    )
  }

  componentDidMount = () => {
    let context = this.props.context
  }

  onNPSubmit = () => {
    let npSubmitted = this.state.npSubmitted
    if (npSubmitted)
      return

    this.setState({
      npSuccessMsg: null,
      npErrorList: [],
      npSubmitted: true
    })

    RestApiUtils.post(this.props.context,
      `/api/su/accounts/${this.props.account.accountId}/creditAssesments/novelPatterns`,
      this.onNPSubmitCallback, {}
    )
  }

  onNPSubmitCallback = (response) => {
    let npErrorList = []
    response.errorList.forEach(error => {
      npErrorList.push(error.message)
    })

    this.setState({
      npSuccessMsg: response.success,
      npErrorList: npErrorList,
      npSubmitted: false
    })

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({ npSuccessMsg: null })
        this.props.onRefreshClick()
      }, 3000)
    }

    if (response.errorList.length) {
      setTimeout(() => {
        this.setState({ npErrorList: [] })
      }, 30000)
    }
  }

  setNPErrorList = (npErrorList) => {
    this.setState({ npErrorList: npErrorList })
  }

  onSMSubmit = () => {
    let smSubmitted = this.state.smSubmitted
    if (smSubmitted)
      return

    this.setState({
      smSuccessMsg: null,
      smErrorList: [],
      smSubmitted: true
    })

    RestApiUtils.post(this.props.context,
      `/api/su/accounts/${this.props.account.accountId}/creditAssesments/scoreMe`,
      this.onSMSubmitCallback, {}
    )
  }

  onSMSubmitCallback = (response) => {
    let smErrorList = []
    response.errorList.forEach(error => {
      smErrorList.push(error.message)
    })

    this.setState({
      smSuccessMsg: response.success,
      smErrorList: smErrorList,
      smSubmitted: false
    })

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({ smSuccessMsg: null })
        this.props.onRefreshClick()
      }, 3000)
    }

    if (response.errorList.length) {
      setTimeout(() => {
        this.setState({ smErrorList: [] })
      }, 5000)
    }
  }

  setSMErrorList = (smErrorList) => {
    this.setState({ smErrorList: smErrorList })
  }

  onDownloadFileClick = (event) => {
    console.log('downloadClicked')
    let fileType = event.currentTarget.getAttribute('data-type')
    let fileName = event.currentTarget.getAttribute('data-file-name')
    let folder = event.currentTarget.getAttribute('data-folder')

    this.setState({ downloadRequested: true })
    RestApiUtils.get(this.props.context,
      `/api/su/accounts/${this.props.account.accountId}/companyReports/files/${fileType}/${fileName}/fileDownloadSignedUrl?folder=${folder}`,
      this.onDownloadFileClickCallback, null, null
    )
  }

  onDownloadFileClickCallback = (response) => {
    this.setState({
      fileErrorList: response.errorList,
      downloadRequested: false
    })

    if (response.errorList.length === 0) {
      const link = document.createElement('a')
      link.href = response.signedUrl.signedUrl
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  }

  onClientTxnsReuploadClick = () => {
    let clientTxnsReuploadSubmitted = this.state.clientTxnsReuploadSubmitted
    if (clientTxnsReuploadSubmitted)
      return

    this.setState({
      clientTxnsReuploadSuccessMsg: null,
      clientTxnsReuploadErrorList: [],
      clientTxnsReuploadSubmitted: true
    })

    RestApiUtils.put(this.props.context,
      `/api/su/accounts/${this.props.account.accountId}/s3/novelPatterns/clientTransactions`,
      this.onClientTxnsReuploadClickCallback, {}
    )
  }

  onClientTxnsReuploadClickCallback = (response) => {
    let clientTxnsReuploadErrorList = []
    response.errorList.forEach(error => {
      clientTxnsReuploadErrorList.push(error.message)
    })

    this.setState({
      clientTxnsReuploadSuccessMsg: response.success,
      clientTxnsReuploadErrorList: clientTxnsReuploadErrorList,
      clientTxnsReuploadSubmitted: false
    })

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({ clientTxnsReuploadSuccessMsg: null })
        this.props.onRefreshClick()
      }, 3000)
    }

    if (response.errorList.length) {
      setTimeout(() => {
        this.setState({ clientTxnsReuploadErrorList: [] })
      }, 5000)
    }
  }

  onDeleteClick = () => {
    if (this.state.deleteSubmitted)
      return

    this.setState({ deleteSubmitted: true })
    RestApiUtils.delete(this.props.context,
      `/api/su/accounts/${this.props.account.accountId}/clientTransactions`,
      this.onDeleteClickCallback, null, null
    )
  }

  onDeleteClickCallback = response => {
    this.setState({ deleteSubmitted: false })

    if (response.errorList.length === 0) {
      this.props.onRefreshClick()
    }
  }

}

export default DocumentUploadSF
